import React, { useState, useEffect, useCallback,useRef } from "react";

import Loadable from 'react-loadable';
import queryString from './querystring';
import { getCookie, setCookie } from 'utils/cookie';
import {
  LANG, F_KEY, S_KEY, C_KEY, O_KEY, P_KEY, CATEGORY,
  LIMIT, COOKIE_ID, USER_TKEY, BEARER_KEY, RFRESH_TOKEN,
  EXPIRES_AT, THAI_TIMEZONE_OFFSET, SHOW_MESSAGE_TO_UI,
  SHOW_LOADER, H1_CHANGED, SESSION_ID
} from 'utils/constants';
import moment from 'moment';

import isEmpty from 'lodash.isempty';
import isPlainObject from 'lodash.isplainobject';
import transform from 'lodash.transform';

const dynaParamSep = ':';


export function dotify(val, maxLength) {
  if (!val) return val;

  if (val && val.length < maxLength - 2) {
    return val;
  } else {
    return val.substring(0, val.length - 3) + '...';
  }
}

export function getApplicationDateFormatString(date) {
  return date ? moment(date).format('DD-MM-YYYY') : '';
}

export function getYmdDate(dt) {
  if (typeof dt === 'string') {
    dt = new Date(dt);
  }
  return dt ? dt.toISOString().split('T')[0] : '';
}
export function getLocalYmdDate(dt) {
  if (typeof dt === 'string') {
    dt = new Date(dt);
  }
  return moment(dt).format('YYYY-MM-DD');
}
export function getLocalYmdHisDate(dt) {
  if (typeof dt === 'string') {
    dt = new Date(dt);
  }
  return moment(dt).format('YYYY-MM-DD HH:mm:ss');
}
export function getLocaldmYDate(dt, dtformat, isUTC = false) {
  if (dt) {
    if (typeof dt === 'string') {
      dt = new Date(dt);
    }
    if (isUTC) {
      return moment(dt).utc().format(dtformat || 'DD-MM-YYYY');
    }
    return moment(dt).format(dtformat || 'DD-MM-YYYY');
  } else {
    return '';
  }
}
export function getLocaldmYHisDate(dt, dtformat) {
  if (dt) {
    if (typeof dt === 'string') {
      dt = new Date(dt);
    }
    return moment(dt).format(dtformat || 'DD-MM-YYYY HH:mm:ss');
  } else {
    return '';
  }
}

export function getLocalTimeAtAppLocation() {
  return getLocalTimeAtTimeZone(app.appLocationHoursOffsetUtc);
}

export function getLocalTimeAtTimeZone(utcTimeZoneOffset) {
  return moment().utcOffset((new Date().getTimezoneOffset() / 60) + parseFloat(utcTimeZoneOffset));
}

export function filterParser([updatedFilter], currentFilter) {
  let filterApplied = false;
  const filter = updatedFilter.f[0];
  currentFilter.f.forEach(f => {
    if (f.field === filter.field) {
      filterApplied = true;
      f.codes = filter.codes;
    }
  });
  if (!filterApplied) {
    currentFilter.f.push(filter);
  }

  // remove all empty valued filters
  currentFilter.f = currentFilter.f.filter(f => f.codes[0]);
  return currentFilter;
};

export function removeFilterKeys(currentFilter, fields = []) {
  currentFilter.f = currentFilter.f.filter(f => fields.indexOf(f.field) === -1);
  return currentFilter;
};

/* Search pimcore with multiple sku Ids */
export function getInSkusSearchQuery(skuIds) {
  const updatedFilter = [
    {
      f: [{
        field: 'skuNumber',
        codes: skuIds,
        conditionConnector: "OR",
        operator: "equals"
      }]
    }
  ];
  const currentFilter = filterParser(updatedFilter, { f: [] });
  let sq = {
    ...currentFilter,
    itemsPerPage: skuIds.length
  };
  return sq;
};

function loading(props) {
  //console.log('loader------');
  if (props.error) {
    //location.reload();
    return <div>{translate('error')} <button onClick={ props.retry }>{translate('retry')}</button></div>;
  } else if (props.timedOut) {
    location.reload();
    //return <div>{translate('taking_long_time')}<button onClick={ props.retry }>{translate('retry')}</button></div>;
  } else if (props.pastDelay) {
    return <div>{translate('loading')}</div>;
  } else {
    return null;
  }
}

export function isInViewport(elem) {
  const padding = 25;
  var bounding = elem.getBoundingClientRect();
  //console.log(bounding);
  return (
    (bounding.top + padding) >= 0 &&
    (bounding.left + padding) >= 0 &&
    (bounding.bottom - padding) <= (window.innerHeight || document.documentElement.clientHeight) &&
    (bounding.right - padding) <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
export function getUID() {
  let cid = queryString.getFromCache(COOKIE_ID);
  !cid && (cid = new Date().getTime().toString(16).toUpperCase()) && queryString.setToCache(COOKIE_ID, cid);
  return cid;
}
export function getUniqueID(){
  return '_' + Math.random().toString(36).substr(2, 9);
}

export function getSessionID() {
  let sid = queryString.getFromCache(SESSION_ID);
  !sid && (sid = new Date().getTime().toString(16).toUpperCase()) && queryString.setToCache(SESSION_ID, sid);
  return sid;
}

export function validUToken(refresh) {
  let d = new Date().getTime();
  let t = queryString.getFromCache(USER_TKEY) || null;
  if (t) {
    let e = parseInt(queryString.getFromCache(EXPIRES_AT) || '0');
    if (e < d) {
      t = null;
      refresh && app.events.trigger(RFRESH_TOKEN);
    }
  }
  return t;
}

export function gotoUrl(url, history) {
  history = history || app.history;
  if (history) {
    history.push(url)
  }
  else {
    window.location.href = url;
  }
}
export function normName(name) {
  return name.trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/gmi, "");
}
export function loadableComp(compId, loaderfn = loading) {
  return Loadable({
    loader: () => import('components/' + compId),
    loading: loaderfn,
    compId: compId
  });
}

export function getQuery(querystr, fromPage = false) {
  //const queryString = require('components/querystring');
  return fromPage ? queryString.parseUrl(window.location.href).query : queryString.parse(querystr);
}

export function getUpdatedPageUrl(key, value, query, url) {
  query = query || queryString.parseUrl(window.location.href).query;
  query[key] = value;

  return getPageUrlWithQuery(url, query);
}

export function getPageUrlWithQuery(url, query) {
  let q = queryString.stringify(query, { removeEmptyValueKeys: true });
  return (url?(url+(q?url.includes('?')?'&':'?':'')):'')+q;
  // return (url ? (url + (q ? '?' : '')) : '') + q;
}

export function resolveApiUrl(urlKey, params = {}, appendParams = true, urlParams = {}) {
  let baseurl;
  if (app.apis[urlKey]) {
    urlKey = app.apis[urlKey];
    baseurl = app.apis.baseurl;
  }  else if (app.auth[urlKey]) {
    urlKey = app.auth[urlKey];
    baseurl = app.auth.baseurl;
  } else if (app.search[urlKey]) {
    urlKey = app.search[urlKey];
    baseurl = app.search.baseurl;
  }  
  else {
    baseurl = app.apis.baseurl;
  }
  return resolveUrl(urlKey, params, baseurl, appendParams, urlParams)
}

export function resolveRouterPath(pathKey, params = {}) {
  return resolveUrl((app.routesMap[pathKey] ? app.routesMap[pathKey].path : pathKey), params, null, false, '', true);
}

export function getCurrentPathWithQuery(params = {}) {
  let url = resolveRouterPath(app.pageInfo.path, params, null, false);
  return getPageUrlWithQuery(url, app.pageInfo.query);
}

function resolveUrl(uri, params = {}, baseurl, appendParams = true, urlParams = {}, isRouterPath) {
  //if(!app.apis[urlKey]) return urlKey;
  params = { ...app.pageParams, ...app.pageInfo.params, ...params };
  urlParams = { ...urlParams, ...app.apis.urlParams };
  if (params['normName'] && params[params['normName']]) {
    params[params['normName']] = normName(params[params['normName']]);
    delete params['normName'];
  }
  let url = [];
  baseurl && url.push(baseurl);
  var httpUrl = false;
  if (uri.startsWith('http://') || uri.startsWith('https://')) {
    if(uri.startsWith('https://'))
    {
      uri = uri.substring(7);
      url = ['https:/'];
    }
    else
    {
      uri = uri.substring(6);
      url = ['http:/'];
    }
    // url = ['http://']; ------ double slashes will be again joined with slash when returning the url below
    httpUrl = true;
  }
 
  for (let urlPart of uri.split('/')) {
    let urlPart2 = urlPart.slice(1);
    if (urlPart.charAt(0) == dynaParamSep && params[urlPart2]) {
      urlPart = params[urlPart2] + '';
      delete params[urlPart2];
    }
    urlPart && urlPart.length && url.push(urlPart);
  }
  let urlP = '';
  if (!isRouterPath) urlP = appendParams ? { ...params, ...urlParams } : urlParams;
  let p = Object.keys(urlP).map(key => {
    let v = urlP[key];
    return v ? (key + '=' + v) : '';
  }).filter(x => x.length > 0).join('&');
  //url = ((baseurl || uri.startsWith('http://'))?'':'/') + url.join('/') + (p.length?(uri.indexOf('?') > 0 ? ('&'+p) : ('?'+p)):''); ---- uri is truncated above so the check uri.startsWith('http') will fail
  url = ((baseurl || httpUrl) ? '' : '/') + url.join('/') + (p.length ? (uri.indexOf('?') > 0 ? ('&' + p) : ('?' + p)) : '');
  return url;
}


export function translate(resourceKey, searchQuery) {
  return app.translations[resourceKey] || resourceKey;
}

export function setPageTitle(title) {
  return document.title = translate('pageTitle');
}

export function getSearchQuery(filters, query, jsonStr, queryFields) {
  let sq = { ...app.pageParams };
  if (query[C_KEY]) {
    let ctgs = query[C_KEY].split(':');
    filters = { ctgr: { field: ctgs[0], type: "", codes: ctgs[1].split(',') }, ...filters };
    // filters = { ctgr: { field: ctgs[0], type: "", codes: [ctgs[1]] }, ...filters };
  }
  let fq = Object.keys(filters).map(k => {
    let v = filters[k];
    return (!v || !v.codes.length) ? '' : v;
  }).filter(x => x && x.codes);
  if (fq.length) sq['f'] = jsonStr ? JSON.stringify(fq) : fq;
  if (query[S_KEY]) {
    let q = { term: query[S_KEY], fields: queryFields?[queryFields]:[] };
    // let q = { term: query[S_KEY], fields: app.queryFields };
    sq['q'] = jsonStr ? JSON.stringify(q) : q;
  }
  if (query[O_KEY] || app.defualtSort) {
    let srder = (query[O_KEY] || app.defualtSort).split(':');
    sq.sort = { field: srder[0], order: (srder[1] || '') };
  }
  if (query[LIMIT]) {
    sq[LIMIT] = parseInt(query[LIMIT]);
  }
  sq.page = query[P_KEY] || 1;
  return sq;
}
export function getStaticContentUrl(uri, host) {
  host = host || app.staticContentHost;
  return !uri || uri.startsWith('http://') || uri.startsWith('https://') ? uri : host + (uri.startsWith('/') ? '' : '/') + uri;
}
export function getBuyerStaticContentUrl(uri, host) {
  host = host || app.assetsStaticContentHost;
  return !uri || uri.startsWith('http://') || uri.startsWith('https://') ? uri : host + (uri.startsWith('/') ? '' : '/') + uri;
}

export function getHoursOffsetDate(date, offset) {
  return new Date(date.getTime() + offset * 3600 * 1000);
}

export function getMidnightDate(d) {
  const dt = new Date(d);
  dt.setHours(0, 0, 0, 0);
  return dt;
}

export function getAppLocationMidnightDate() {
  return getMidnightDate(
    getAppLocationDate()
  );
}
export function getAppLocationDate(date) {
  if (!date) {
    date = new Date();
  }
  return getHoursOffsetDate(date, THAI_TIMEZONE_OFFSET)
}

export function isUndefined(input) {
  if (typeof input === 'undefined' || input === null || input === '')
    return true;
  else
    return false;
}
export function withCurrencySymbol(value) {
  return (app.currency + ' ' + round(value, 2));
}
export function currencyNumberFormat(number) {
  return new Intl.NumberFormat('th', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(number)
}
export function setUserToken(userAuth, loginUser) {
  queryString.setToCache(USER_TKEY, BEARER_KEY + userAuth.accessToken);
  //removeFromCache(LOGIN_USER_DATA);
  //loginUser && queryString.setToCache(LOGIN_USER_DATA,LOGIN_USER_DATA);
}
export function setLang(lang) {
  setCookie(LANG, lang);
  document.body.attributes.lang.value = lang;
}
export function appendEnvClass(countryCode) {
  if (countryCode) {
    document.body.classList.add('env-' + countryCode.toLowerCase());
  }
}
export function round(value, decimalPlace) {
  decimalPlace = decimalPlace || 1;
  let p = Math.pow(10, decimalPlace);
  return Math.round(value * p) / p;
}
export function toastMessage(message, msgType) {
  app.events.trigger(SHOW_MESSAGE_TO_UI, { message, msgType });
}
export function toggleLoader(loaderStatus) {
  app.events.trigger(SHOW_LOADER, { status: loaderStatus });
}

export function updateNestedObject(obj, keyPath, value) {
  let lastKeyIndex = keyPath.length - 1;
  for (var i = 0; i < lastKeyIndex; ++i) {
    let key = keyPath[i];
    if (!(key in obj))
      obj[key] = {}
    obj = obj[key];
  }
  obj[keyPath[lastKeyIndex]] = value;
}
// export function getNestedObject(obj, keyPath) {
//   let lastKeyIndex = keyPath.length-1;
//   for (var i = 0; i < lastKeyIndex; ++ i) {
//     let key = keyPath[i];
//     if (!(key in obj))
//       obj[key] = {}
//     obj = obj[key];
//   }
//   return obj[keyPath[lastKeyIndex]];
// }

export function getNestedObject(nestedObj, pathArr) {
  return pathArr.reduce((obj, key) =>
    (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
}
// pass in your object structure as array elements
//const name = getNestedObject(user, ['personalInfo', 'name']);
// to access nested array, just pass in array index as an element the path array.
//const city = getNestedObject(user, ['personalInfo', 'addresses', 0, 'city']);
// this will return the city from the first address item.


/* 
  @cleanDeep
  const object = {
    bar: {},
    baz: null,
    biz: 'baz',
    foo: '',
    net: [],
    nit: undefined,
    qux: {
      baz: 'boz',
      txi: ''
    }
  };
  cleanDeep(object); 
  => { biz: 'baz', qux: { baz: 'boz' } }
*/
export function cleanDeep(object, {
  emptyArrays = true,
  emptyObjects = true,
  emptyStrings = true,
  nullValues = true,
  undefinedValues = true,
  trimStrings = true
} = {}) {
  return transform(object, (result, value, key) => {
    // Recurse into arrays and objects.
    if (Array.isArray(value) || isPlainObject(value)) {
      value = cleanDeep(value, { emptyArrays, emptyObjects, emptyStrings, nullValues, undefinedValues, trimStrings });
    }

    // Exclude empty objects.
    if (emptyObjects && isPlainObject(value) && isEmpty(value)) {
      return;
    }

    // Exclude empty arrays.
    if (emptyArrays && Array.isArray(value) && !value.length) {
      return;
    }

    // Exclude empty strings.
    if (emptyStrings && value === '') {
      return;
    }

    // Exclude empty strings with trim.
    if (emptyStrings && trimStrings && typeof value === 'string' && value.trim() === '') {
      return;
    }


    // Exclude null values.
    if (nullValues && value === null) {
      return;
    }

    // Exclude undefined values.
    if (undefinedValues && value === undefined) {
      return;
    }

    // Append when recursing arrays.
    if (Array.isArray(result)) {
      return result.push(value);
    }

    result[key] = value;
  });
}

export function checkPasswordCmp(password) {
  let m = 0;
  if (password.match(".*[a-z]+.*")) {
    m++;
  }
  // if(password.match(".*[A-Z]+.*"))
  // {
  //     m++;
  // }
  if (password.match(".*[0-9]+.*")) {
    m++;
  }
  /*if(password.match(/[!@#$%^&*(),.?":{}|<>]/g))
  {
      m++;
  }*/
  return m > 1;
}
export function checkemailphone(value) {
  var isnum = /^\d+$/.test(value);
  // if(isnum) return(value.length <5 || value.length>15)
  if (isnum) return (value.length > 5 && value.length < 15)
  else {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
  }
}

export function checkeOTP(value) {
  var isnum = /^\d+$/.test(value);
  // if(isnum) return(value.length <5 || value.length>15)
  if (isnum) return (value.length == 6)
  else {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
  }
}

export function checkphone(value) {
  let phoneno;
  if (value.includes('+')) {
    phoneno = value.substring(3);
  } else phoneno = value;

  var isnum = /^\d+$/.test(phoneno);
  return (isnum && (phoneno.length > 5 && phoneno.length < 15))
}

export function maskedEmail(email) {
  let emailParts = email.split('@');

  return (emailParts[0].length > 3 ? emailParts[0].substring(0, 3) : emailParts[0].charAt(0)) + '***@' + emailParts[1];
}

export function isAdminSession() {
  return (app.userAuth && (app.userAuth.isAdmin || app.userAuth.impersonateUserEmail));
}

export function stripHtmlTags(html) {
  const tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gim
  return html.replace(tags, '');
}

export function isPageEnabled(pageName) {
  if (app.disabledPages && app.disabledPages.length) {
    return !app.disabledPages.includes(pageName);
  } else {
    return true;
  }
}

export function trimIfPossible(str) {
  if (str && typeof str === 'string') {
    return str.trim();
  }
  return str;
}

export function changeH1(title) {
  app.events.trigger(H1_CHANGED, { title })
}

export function getTimeZoneLabel() {
  if (app.timeZone && app.appLocationHoursOffsetUtc) {
    const offset = (app.appLocationHoursOffsetUtc > 0 ? '+' : '-') + ' ' + app.appLocationHoursOffsetUtc;
    return app.timeZone + ' : GMT ' + offset;
  } else {
    return '';
  }
}

export function getFilePath(filepath) {
  if (filepath.indexOf('http') == -1) {
    if (filepath.substring(0, 1) == "/") {
      return location.origin + filepath;
    } else {
      // if (filepath.indexOf('promotion-service') != -1) {
      //   return location.origin + '/seller/' + filepath;
      // } else {
      //   return location.origin + '/seller-service/' + filepath;
      // }
    }
  }
  return filepath;
}

 
export function isEmptyChk(val){
  return val === null ||
  val === undefined ||
  (val.hasOwnProperty("length") && val.length === 0) ||
  (val.constructor === Object && Object.keys(val).length === 0)
}

export function renderHTML(rawHTML) {
  return React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
} 

export function hasPageAccess(resourceCode){
  let privilegeList= app.userAuth.privilegeList;
  if(!privilegeList || (privilegeList && isEmpty(privilegeList))) return true;

  let itemsWithCode = privilegeList.filter(item=> item.includes(resourceCode));
  return !itemsWithCode.length || (itemsWithCode.length && !itemsWithCode.includes(resourceCode+":NO_ACCESS"))
}
export function isReadOnlyChk(resourceCode){
  let privilegeList= app.userAuth.privilegeList;
  if(!privilegeList || (privilegeList && isEmpty(privilegeList))) return false;
  let itemsWithCode = privilegeList.filter(item=> item.includes(resourceCode));
  return !!itemsWithCode.length || (itemsWithCode.length && itemsWithCode.includes(resourceCode+":READ_ACCESS"))
}

export function useToggle(initialValue) {
  const [toggleValue, setToggleValue] = useState(initialValue);
  const toggler = useCallback(() => setToggleValue(prevValue => !prevValue), []);

  return [toggleValue, toggler];
}

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value])
  return ref.current;
}
export function useInstance(initialValue){
  ////Inform the child component that it is newly rendered with new props. instance wil increment in each render
  const [count, setCount] = useState(initialValue);
  const countChange = useCallback(()=> setCount(prevValue => prevValue+1),[])
  return [count, countChange]
}
export function stopPropagation(event) {
  event.stopPropagation();
}

export function downloadFile(filePath) {
  const a = document.createElement('a');
  a.href = filePath;
  a.download = filePath.substr(filePath.lastIndexOf('/') + 1);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
export function updateAliasFilters(filters)
{
  let arr = Array.isArray(filters);
  let filterMap = arr?{}:filters;
  if(arr){
    filters.forEach(f=>{
      filterMap[f.field] = {...f};
    })
  }
  Object.keys(app.aliasFilters).forEach(fk=>{
    if(filterMap[fk]){
      let aFtr = app.aliasFilters[fk];
      if(!filterMap[aFtr]){
        filterMap[aFtr] = {field:aFtr,operator:filterMap[fk].operator,codes:[]};
      }
      !filterMap[aFtr].codes.includes(fk) && filterMap[aFtr].codes.push(fk);
      delete filterMap[fk];
    }
  });
  return arr?Object.values(filterMap):filterMap;
}
export function getSearchArrFromQuery(query,currentFilter={}){
  let qstr = query[S_KEY];
  if(qstr){
    for (let flr of qstr.split(',')) {
        let flr2 = flr.replace(/\%2C/g,',').split(':');
        flr2[0] = flr2[0].replace(/\%3A/g,':');
        flr2[2] = (flr2[2] || '').replace(/\%3A/g,':').replace(/\|/g,'@@@@@').replace(/\%7C/g,'|');
        currentFilter[flr2[0]] = {...(currentFilter[flr2[0]] || {}),fields:(flr2[0]||'').split('@@@@@'),operator:flr2[1],term:flr2[2]};
        // currentFilter[flr2[0]] = {...(currentFilter[flr2[0]] || {}),term2:flr2[0],operator:flr2[1],fields:(flr2[2]||'').split('@@@@@')};
    }  
  }
  return currentFilter;
}
export function getFilterFromQuery(query,currentFilter={}){
  let qstr = query[F_KEY];
  if(qstr){
    for (let flr of qstr.split(',')) {
        let flr2 = flr.replace(/\%2C/g,',').split(':');
        flr2[0] = flr2[0].replace(/\%3A/g,':');
        flr2[2] = (flr2[2] || '').replace(/\%3A/g,':').replace(/\|/g,'@@@@@').replace(/\%7C/g,'|');
        currentFilter[flr2[0]] = {...(currentFilter[flr2[0]] || {}),field:flr2[0],operator:flr2[1],codes:(flr2[2]||'').split('@@@@@')};
    }  
  }
  
  /* Object.keys(app.aliasFilters).forEach(fk=>{
    if(currentFilter[fk]){
      let aFtr = app.aliasFilters[fk];
      if(!currentFilter[aFtr]){
        currentFilter[aFtr] = {field:aFtr,operator:currentFilter[fk].operator,codes:[]};
      }
      currentFilter[aFtr].codes.push(fk);
      delete currentFilter[fk];
    }
  }); */
  return currentFilter// updateAliasFilters(currentFilter);
}
